import React from 'react';

import { Box, IconButton, Typography } from '@mui/material';

import { DeleteIcon } from './CustomIcons';

import { IAnswerCard } from '../../constants/types';

const boxStyles = {
  bgcolor: 'common.white',
  mb: 2,
  pl: 2,
  pr: 1,
  py: 1,
  border: '1px solid',
  borderColor: 'info.main',
  borderRadius: 6,
  display: 'flex',
  alignItems: 'center',
};

const typographyStyles = {
  fontWeight: 600,
  flexGrow: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const AnswerCard: React.FC<IAnswerCard> = React.memo(
  ({ answerText, index, onDelete }) => {
    const handleDelete = () => onDelete(index);

    return (
      <Box sx={boxStyles}>
        <Typography sx={typographyStyles}>{answerText}</Typography>
        <IconButton onClick={handleDelete} color="primary">
          <DeleteIcon sx={{ width: 24, height: 24 }} />
        </IconButton>
      </Box>
    );
  }
);

export default AnswerCard;
